module.exports = __webpack_public_path__ + "static/img/product01-4.77581c6c.png";